export const reduceToObjectFromPairs = (obj: Object, [prop, val]) => {
  obj[prop] = val;
  return obj;
};

export const objectFromPairs = (arr: []) => arr.reduce(reduceToObjectFromPairs, {});

export default objectFromPairs;
